var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDevBoxStopped = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7760_315371)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32.1474 15.6507C32.0994 13.938 31.4424 12.2985 30.2944 11.0265C29.1464 9.75461 27.5827 8.93351 25.884 8.7107C25.7813 6.31762 24.7392 4.06148 22.9839 2.43166C21.2287 0.801826 18.9016 -0.0703009 16.5075 0.00443599C14.574 -0.0328645 12.6766 0.530991 11.0772 1.61816C9.4779 2.70532 8.25553 4.26218 7.57883 6.07376C5.53268 6.32145 3.64301 7.29424 2.25257 8.81568C0.862121 10.3371 0.0629537 12.3065 0 14.3667C0.0889044 16.6803 1.09154 18.8644 2.78814 20.44C4.48472 22.0157 6.73682 22.8543 9.05077 22.7723L9.84936 22.7409H24.5153C24.6469 22.7388 24.7774 22.7187 24.9036 22.6815C26.7832 22.6667 28.585 21.9281 29.9339 20.6193C31.283 19.3105 32.0757 17.5321 32.1474 15.6538V15.6507Z",
    fill: "url(#paint0_linear_7760_315371)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7049 13.5723H12.3651C11.8258 13.5723 11.3887 14.0094 11.3887 14.5487V32.1242C11.3887 32.6636 11.8258 33.1007 12.3651 33.1007H39.7049C40.244 33.1007 40.6814 32.6636 40.6814 32.1242V14.5487C40.6814 14.0094 40.244 13.5723 39.7049 13.5723Z",
    fill: "url(#paint1_linear_7760_315371)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9098 39.0078C29.0131 38.5522 28.8992 36.4692 28.8992 33.1006H23.1547C23.1547 36.4692 23.057 38.5522 20.1603 39.0078C19.7604 39.0522 19.3911 39.2428 19.1236 39.5435C18.8562 39.8439 18.7095 40.233 18.7119 40.6352H33.3582C33.3607 40.233 33.214 39.8439 32.9466 39.5435C32.679 39.2428 32.3098 39.0522 31.9098 39.0078Z",
    fill: "url(#paint2_linear_7760_315371)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7760_315371",
    x1: 16.1859,
    y1: 22.8575,
    x2: 16.1859,
    y2: 0.00460403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#198AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22A5CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#29BADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#2EC9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#31D1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#32D4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7760_315371",
    x1: 26.035,
    y1: 33.1007,
    x2: 26.035,
    y2: 13.5723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5EA0EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7760_315371",
    x1: 26.0352,
    y1: 40.6352,
    x2: 26.0352,
    y2: 33.1006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707070"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7760_315371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDevBoxStopped);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dev-box-stopped.89c53b0dc550c5174d6f60a2e3c1c7d8.svg";